import { createUseStyles } from "react-jss";

export default createUseStyles((theme: any) => ({
    secQuestionTitle: {
        composes: "question__title",
        padding: "5px 0"
    },
    secQuestionText: {
        composes: "question__text",
        padding: "10px 0",
    },
    textAnswer: {
        composes: "text-answer",
    },
    securityQuestionContainer: {
        padding: "20px 0",
    },
    questionValidation: {
        alignItems: "center",
        composes: "question__validation",
        display: "inline-flex",
    },
    questionContainer: {
        marginBottom: "15px",
    },
    answerContainer: {
        marginBottom: "20px",
    },
    questionValidationFocus: {
        borderLeftColor: ({ theme }) => theme.ErrorColor,
        composes: "question__validation-focus",
    },
    dynamicQuestionValidationFocus: {
        borderLeftStyle: "solid",
        borderLeftWidth: 3,
        left: -30,
        paddingLeft: 30,
        position: "relative",
        width: "100%",
    },
}))